import $ from 'jquery';

$.initialize('[data-role="ajax-button"][data-url]', function () {
  $(this).ajaxButton();
});

$.fn.ajaxButton = function (success, fail) {
  let $this = $(this);

  $this.off('click.ajaxButton');

  let handleClick = function () {
    if ($this.data('confirm-title') || $this.data('confirm-text')) {
      $this.lpConfirm('default', request);
    } else {
      request();
    }

    return false;
  };

  let request = function () {
    var rawData = Object.assign({}, $this.data()).filterKeys('post+'), // => {postParam: ..., postParam2 : ...}
      data = {},
      target = $this.attr('target') || $this.data('target');

    for (var key in rawData) {
      var k = key.substr(4).toLocaleLowerCase();
      data[k] = rawData[key];
    }

    if (target) {
      window.Browser.redirectPost($this.data('url'), data, target);
    } else {
      window.Browser.send(
        $this.data('url'),
        data,
        function (json) {
          if (typeof success == 'function') {
            success.call($this.get(0), json);
          } else if ($this.data('onsuccess')) {
            var event = $this.data('onsuccess');
            if (event.startsWith('redirect:')) {
              window.location = event.replace('redirect:', '');
            } else if (event.startsWith('new-window:')) {
              window.open(event.replace('new-window:', ''));
            } else if (event.startsWith('close-window')) {
              var closeWindow = function () {
                window.location = '/'; // if closing does not work
                window.open('', '_self').close(); // close window (only works with js-opened-windows)
              };
              setTimeout(closeWindow, 1);
              return false;
            }
          } else {
            /* empty */
          }
        },
        function (json) {
          if (typeof fail == 'function') {
            fail.call($this.get(0), json);
          } else if ($this.data('onfail')) {
            var event = $this.data('onfail');
            if (event.startsWith('redirect:')) {
              window.location = event.replace('redirect:', '');
            }
          }
        },
        false
      );
    }
  };

  $this.on('click.ajaxButton', handleClick);
  $this.data('ajaxButtonHandler', handleClick);
};
